import state from './moduleAcademicsState.js'
import mutations from './moduleAcademicsMutations.js'
import actions from './moduleAcademicsActions.js'
import getters from './moduleAcademicsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}